/* ===========================================================================
   pdp-thumbs-flechas.js -- PDP-FLECHAS-EN-MINIATURAS
   Dos botones de aviso y navegacion sobre la tira de miniaturas de la ficha.

   FUENTE DE VERDAD: la instancia de Swiper de la tira
   (.product__media-gallery-thumbails). No se anade NINGUN listener de scroll
   en paralelo: el estado se recalcula desde los eventos de la propia instancia
   (progress, setTranslate, transitionEnd, slideChange, fromEdge,
   reachBeginning, reachEnd, update, observerUpdate, breakpoint...).

   POR QUE progress Y NO SOLO isBeginning/isEnd: la tira corre con
   freeMode:true y ademas main-product.liquid le monta un manejador de rueda
   propio que la mueve con setTranslate()/updateProgress() sin cambiar de
   slide. Con freeMode, slideChange no se dispara en cada movimiento; progress
   si -- updateProgress lo emite -- asi que es el unico gancho que ve TODOS los
   desplazamientos, incluido el de la rueda.

   NO SE TOCA LA CONFIGURACION DE SWIPER. No se escribe en sw.params, no se
   llama a sw.update() ni a destroy/init, y no se registra el modulo Navigation
   sobre la instancia: los botones son elementos propios con su propio estado.

   DEFECTO PREEXISTENTE CONOCIDO (<768, tira horizontal): el modelo interno de
   Swiper cree que cada celda mide 80.5px (el width inline que le pone
   slidesPerView:4) mientras el flex-basis:96px de pdp-maha.css la pinta a 96.
   Su maxTranslate se queda 194px corto y la ultima miniatura NO es alcanzable
   -- ni arrastrando, ni con update(): medido, translate se clava en -370 y la
   ultima celda queda 194px fuera de la caja. Este archivo NO lo arregla (eso
   exigiria tocar pdp-maha.css o la configuracion de Swiper, ambos fuera de
   alcance) y a proposito NO lo disimula: los limites de las flechas son los de
   Swiper, de modo que un boton visible SIEMPRE puede mover algo y un boton
   apagado significa "hasta aqui llega este carrusel".
   =========================================================================== */
(function () {
  'use strict';

  var SEL_TIRA = '.product__media-gallery-thumbails';
  var SEL_CELDA = '.product__thumbs-item';

  /* TOLERANCIA -- 2px. Es un MARGEN, no el parche de un ruido observado, y
     conviene decirlo tal cual porque lo medido fue esto:

       - Residuo |translate - maxTranslate| tras 30 idas y venidas al tope,
         a 1440 y con devicePixelRatio 1, 2, 2.625 y 3: 0.000000 en los cuatro.
       - Residuo tras arrastres reales con inercia de freeMode: 0.000000, y la
         fraccion de translate en el tope, 0.
       - Dispersion del paso entre celdas en esos mismos cuatro dpr: 0.0000 px.

     O sea que hoy, en este motor, un umbral de 0 tambien acertaria. La razon de
     no dejarlo en 0 es que la igualdad exacta entre sw.translate y
     sw.maxTranslate() depende de que ambos salgan del mismo clamp, y eso si
     tiene fracciones donde mirar: por debajo de 768 slidesSizesGrid vale 80.5,
     virtualSize y maxTranslate heredan esos medios pixeles, y a media tira se
     midio un translate de -277.5. Basta con que un motor redondee la matriz de
     transformacion, o que la inercia resuelva en un frame distinto, para dejar
     unas decimas y hacer parpadear la flecha.
     Por que 2 y no 1: cubre dos fuentes de redondeo sumadas sin tener que
     medirlas por separado. Por que no mas: 2px es el 1.7% de una miniatura de
     118px, asi que la tolerancia nunca puede apagar la flecha dejando una
     miniatura -- ni un trozo apreciable de ella -- todavia escondida. */
  var TOL = 2;

  var GLIFOS = {
    arriba: 'M3 8.5 L7 4.5 L11 8.5',
    abajo: 'M3 5.5 L7 9.5 L11 5.5',
    izquierda: 'M8.5 3 L4.5 7 L8.5 11',
    derecha: 'M5.5 3 L9.5 7 L5.5 11'
  };

  function svg(d) {
    return (
      '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="' + d + '" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>'
    );
  }

  function esVertical(sw) {
    return !!(sw && sw.params && sw.params.direction === 'vertical');
  }

  function Controlador(tira) {
    this.tira = tira;
    this.sw = tira.swiper;
    this.botones = {};
    this.desmontar = [];
    this.pendiente = false;
    this.crear();
    this.enganchar();
    this.refrescar();
  }

  Controlador.prototype.crear = function () {
    var self = this;
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pfm-flecha pfm-flecha--' + dir;
      b.setAttribute('data-pfm-dir', dir);
      b.innerHTML = '<span class="pfm-flecha__pastilla"></span>';
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        self.mover(dir);
      });
      self.tira.appendChild(b);
      self.botones[dir] = b;
    });
  };

  /* Etiquetas en espanol. Se reescriben en cada refresco porque la orientacion
     cambia con el ancho de la ventana: columna a partir de 768, fila debajo. */
  Controlador.prototype.etiquetar = function (vertical) {
    var t = vertical
      ? {
          prev: ['Ver miniaturas anteriores', GLIFOS.arriba],
          next: ['Ver mas miniaturas', GLIFOS.abajo]
        }
      : {
          prev: ['Ver miniaturas anteriores', GLIFOS.izquierda],
          next: ['Ver mas miniaturas', GLIFOS.derecha]
        };
    var self = this;
    ['prev', 'next'].forEach(function (dir) {
      var b = self.botones[dir];
      if (b.__pfmGlifo !== t[dir][1]) {
        b.querySelector('.pfm-flecha__pastilla').innerHTML = svg(t[dir][1]);
        b.__pfmGlifo = t[dir][1];
      }
      if (b.getAttribute('aria-label') !== t[dir][0]) {
        b.setAttribute('aria-label', t[dir][0]);
        b.setAttribute('title', t[dir][0]);
      }
    });
    this.tira.classList.toggle('pfm-tira--vertical', vertical);
    this.tira.classList.toggle('pfm-tira--horizontal', !vertical);
  };

  /* Paso de UN CLIC = UNA miniatura.
     Por que una y no una pantalla: a 1440 caben 4 enteras de 8 y a 768 caben 2
     de 8. Con una pantalla, cada clic sustituiria TODO lo visible y el usuario
     perderia la referencia de donde estaba; con una miniatura siempre siguen
     en pantalla las que ya veia menos una, y el recorrido completo son 3-5
     clics. El paso se mide del DOM (distancia real entre el borde de una celda
     y el de la siguiente), no de slidesSizesGrid, porque debajo de 768 esa
     rejilla no coincide con lo pintado. */
  Controlador.prototype.paso = function (vertical) {
    var celdas = this.tira.querySelectorAll(SEL_CELDA);
    if (celdas.length > 1) {
      var a = celdas[0].getBoundingClientRect();
      var b = celdas[1].getBoundingClientRect();
      var p = vertical ? b.top - a.top : b.left - a.left;
      if (p > 1) return p;
    }
    if (celdas.length) {
      var r = celdas[0].getBoundingClientRect();
      var s = vertical ? r.height : r.width;
      if (s > 1) return s;
    }
    return 100;
  };

  Controlador.prototype.mover = function (dir) {
    var sw = this.sw;
    if (!sw || sw.destroyed) return;
    var min = sw.minTranslate();
    var max = sw.maxTranslate();
    var paso = this.paso(esVertical(sw));
    var actual = sw.translate;
    var destino = actual + (dir === 'prev' ? paso : -paso);
    destino = Math.max(max, Math.min(min, destino));
    if (Math.abs(destino - actual) < 0.5) return;

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ms = reduce ? 0 : 300;

    if (typeof sw.translateTo === 'function') {
      sw.translateTo(destino, ms);
    } else {
      sw.setTransition(ms);
      sw.setTranslate(destino);
      sw.updateProgress(destino);
      sw.updateActiveIndex();
      sw.updateSlidesClasses();
    }
    this.refrescar();
  };

  Controlador.prototype.refrescar = function () {
    var sw = this.sw;
    if (!sw || sw.destroyed) return;
    var vertical = esVertical(sw);
    this.etiquetar(vertical);

    var min = sw.minTranslate();
    var max = sw.maxTranslate();
    var recorrido = min - max; // > 0 cuando hay algo que desplazar
    var actual = sw.translate;
    var desdeInicio = min - actual; // cuanto se ha avanzado ya
    var hastaFinal = actual - max; // cuanto queda por avanzar

    var cabeTodo = !(recorrido > TOL) || sw.isLocked === true;
    this.aplicar('prev', !cabeTodo && desdeInicio > TOL);
    this.aplicar('next', !cabeTodo && hastaFinal > TOL);
  };

  Controlador.prototype.aplicar = function (dir, visible) {
    var b = this.botones[dir];
    if (!b) return;
    if (b.__pfmVisible === visible) return;
    b.__pfmVisible = visible;
    b.disabled = !visible;
    b.setAttribute('aria-hidden', visible ? 'false' : 'true');
    b.tabIndex = visible ? 0 : -1;
  };

  Controlador.prototype.enganchar = function () {
    var self = this;
    var sw = this.sw;
    var refrescar = function () {
      self.refrescar();
    };

    // 1. La instancia de Swiper: unica fuente de verdad del desplazamiento.
    [
      'progress',
      'setTranslate',
      'transitionEnd',
      'slideChange',
      'fromEdge',
      'toEdge',
      'reachBeginning',
      'reachEnd',
      'update',
      'observerUpdate',
      'resize',
      'breakpoint',
      'snapGridLengthChange',
      'slidesLengthChange'
    ].forEach(function (ev) {
      sw.on(ev, refrescar);
      self.desmontar.push(function () {
        try {
          sw.off(ev, refrescar);
        } catch (e) {}
      });
    });

    // 2. Cambio de tamano de ventana. El tema NO carga el modulo Resize de
    //    Swiper (theme.js:356 solo monta Navigation, Pagination y A11y, mas
    //    Thumbs), asi que el evento resize de la instancia puede no llegar
    //    nunca: hace falta observar la caja por nuestra cuenta.
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        if (self.pendiente) return;
        self.pendiente = true;
        requestAnimationFrame(function () {
          self.pendiente = false;
          refrescar();
        });
      });
      ro.observe(this.tira);
      this.desmontar.push(function () {
        try {
          ro.disconnect();
        } catch (e) {}
      });
    }
    var onResize = function () {
      requestAnimationFrame(refrescar);
    };
    window.addEventListener('resize', onResize, { passive: true });
    this.desmontar.push(function () {
      window.removeEventListener('resize', onResize);
    });

    // 3. Cambio en el numero de miniaturas (otra variante, otra galeria).
    //    Se observa el DOM en vez de suscribirse a FoxTheme.pubsub: publish()
    //    de este tema no lleva try/catch, y un throw nuestro cortaria al resto
    //    de suscriptores.
    var wrap = this.tira.querySelector('.swiper-wrapper');
    if (wrap && window.MutationObserver) {
      var mo = new MutationObserver(function () {
        requestAnimationFrame(refrescar);
      });
      mo.observe(wrap, { childList: true });
      this.desmontar.push(function () {
        try {
          mo.disconnect();
        } catch (e) {}
      });
    }
  };

  /* --- Arranque -----------------------------------------------------------
     La tira se crea tarde (media-gallery.js espera a FoxTheme.Swiper) y ademas
     se destruye y se rehace al cruzar el corte movil/escritorio. Se sondea
     hasta encontrarla y despues se vigila que la instancia siga siendo la
     misma; si Swiper se rehace, se vuelve a montar sobre la nueva. */
  function tiras() {
    return Array.prototype.slice.call(document.querySelectorAll(SEL_TIRA));
  }

  function montar() {
    tiras().forEach(function (tira) {
      try {
        var sw = tira.swiper;
        if (!sw || !sw.slides || !sw.slides.length) return;
        if (tira.__pfmCtrl && tira.__pfmCtrl.sw === sw && !sw.destroyed) return;
        if (tira.__pfmCtrl) {
          tira.__pfmCtrl.desmontar.forEach(function (f) {
            f();
          });
          Array.prototype.slice
            .call(tira.querySelectorAll('.pfm-flecha'))
            .forEach(function (b) {
              b.remove();
            });
        }
        tira.__pfmCtrl = new Controlador(tira);
        window.__pfmFlechasOn = true;
      } catch (e) {
        /* Nunca romper la ficha por las flechas. */
        if (window.console && console.warn) console.warn('[pfm]', e);
      }
    });
  }

  var intentos = 0;
  var reloj = setInterval(function () {
    intentos++;
    montar();
    if (intentos >= 60) clearInterval(reloj); // ~15 s: ficha sin tira
  }, 250);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }
  window.addEventListener('load', montar);
})();
